export default {
    mate: {},
    adminLogin: {
        user_info: { UserName: "", TrueName: "", LoginDate: "" },
        zone_info: {
            Dimension: "",
            IsStandard: 0,
            IsZhongpai: 0,
            Longitude: "",
            OrganMapPic: "",
            address: "",
            app_url: "",
            area: "",
            auth_num: 0,
            bg_pic: "",
            core_business: "0",
            discript: "",
            email: "",
            fax: "",
            good_business: "",
            logo: "",
            miroblog_pic: "",
            organ_id: "",
            organ_map: "",
            organ_name: "",
            organization_pic: "",
            phone: "",
            post: "",
            regiter_time: "",
            simple_name: "",
            top_bg_pic: "",
            web_url: "",
            zone_name: "",
        }

    }
}